export const CATEGORY_MAP: Record<string, string> = {
  orders_inventory_discrepancies: "inventoryDiscrepancy",
  order_creation: "orderCreation",
  returns_daily_status_needaction: "dailyReturnsNeedAction",
  returns_daily_status_readytoship: "dailyReturnReadyToShip",
  returns_daily_status_rejected: "dailyReturnRejected",
  returns_daily_status_completed: "dailyReturnCompleted",
  returns_daily_status_created: "dailyReturnCreated",
  returns_daily_status_dealerpreparation: "dailyReturnDealerPreparation",
  returns_surplus_status_created: "surplusReturnCreated",
  returns_surplus_status_readytoship: "surplusReturnReadyToShip",
  returns_surplus_status_completed: "surplusReturnCompleted",

  claims_status_rejected: "claimsRejected",
  claims_status_completed: "claimsCompleted",
  claims_status_needaction: "claimsNeedAction",
  d2d_seller_order_requests: "d2dOrderRequestNeedAction",
  d2d_buyer_order_status_updates: "d2dOrderAccepted",
  d2d_order_status_accepted: "d2dOrderAccepted",
  d2d_order_status_shipped: "d2dOrderShipped",
  broadcast_message_created: "broadcastMessageCreated",
  broadcast_message_updated: "broadcastMessageUpdated",
  returns_surplus_status_needaction: "surplusReturnsNeedAction",
  returns_surplus_status_waitingfornfe: "surplusReturnsWaitingForNfe",
  returns_surplus_status_dealerpreparation: "surplusReturnsDealerPreparation",
};
